var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotomedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 16.5h6.5c2.54 0 4.25-1.78 4.25-4.44V5.94c0-2.66-1.7-4.44-4.25-4.44h-6.5C3.21 1.5 1.5 3.28 1.5 5.94v6.12c0 2.66 1.7 4.44 4.25 4.44Zm.62-8.25a1.88 1.88 0 1 1 0-3.75 1.88 1.88 0 0 1 0 3.75Zm8.5 2.95c.25.64.12 1.42-.15 2.06a2.77 2.77 0 0 1-1.7 1.58c-.34.11-.7.16-1.05.16H5.65A3.1 3.1 0 0 1 4 14.57c-.28-.18-.33-.59-.12-.85l1.06-1.33c.67-.85 1.12-1.1 1.63-.88.2.09.4.22.62.36.56.38 1.34.91 2.37.34.7-.4 1.12-1.07 1.47-1.66v-.01l.08-.13c.12-.2.24-.39.38-.57.16-.22.78-.93 1.59-.43.5.32.94.75 1.4 1.2.18.18.3.38.39.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotomedium);
export default __webpack_public_path__ + "static/media/photo.medium.f0e256b2080d7af15fc41869984fe396.svg";
export { ForwardRef as ReactComponent };